<template>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Filtro</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-autocomplete
                  v-model="filter.vendedor"
                  :items="vendedores"
                  item-text="name"
                  item-value="name"
                  label="Vendedor"
                  clearable
                  hide-details
                  hide-selected
                  solo
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6" md="6">
                <v-autocomplete
                  v-model="filter.segmento"
                  :items="segmentos"
                  item-text="descricao"
                  item-value="descricao"
                  label="Segmento"
                  clearable
                  hide-details
                  hide-selected
                  solo
                ></v-autocomplete>
              </v-col>
              
              <hr>
              <v-col cols="6" sm="6" md="6">

                <v-radio-group
                    v-model="filter.order"
                    inline
                >
                
                <template v-slot:label>
                    <div>Ordem Alfabetica</div>
                </template>
                    <v-radio
                        label="Ordernar"
                        value="1"
                    ></v-radio>
                    <v-radio
                        label="Não Ordernar"
                        value="-1"
                    ></v-radio>
                </v-radio-group>
            </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('close')">
            Cancelar
          </v-btn>
          <v-btn color="red" text @click="clearFilter">
            Limpar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'MofalFilterClientView',
    props: ['open'],
    data() {
        return {
            filter: {
                vendedor: null,
                segmento: null,
                order: "1"
            },
            dialog: false,
            vendedores: [],
            segmentos: []
        };
    },
    watch: {
        open(newVal) {
            this.dialog = newVal;

            if(newVal && this.vendedores.length === 0) {
                this.getVendedor();
            }

            if(newVal && this.segmentos.length === 0) {
                this.getSegmentos();
            }
        },

        dialog(newVal) {
            if(!newVal) {
                this.$emit('close');
            }
        },

        filter: {
            handler() {
                this.$emit('filter-applied', this.filter)
            },
            deep: true
        }
    },
    methods: {
        async getVendedor() {
            const response = await Vue.prototype.$http.get('/Entity/Collaborator/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000
                }
            })
            this.vendedores = response.data.data.data

        },

        async getSegmentos(){
            const response = await Vue.prototype.$http.get('/Entity/ClienteSegmentoDeMercado/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000
                }
            })

            this.segmentos = response.data.data.data
        },

        clearFilter(){
            this.filter = {
                fornecedorId: null,
                filterdescricaoMaterial: null,
                order: "1"
            }
        }
    }
}

</script>